module.exports = __webpack_public_path__ + "static/media/stmartins_coffee.3853a8ac.jpg";